"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppProvider = void 0;
const React = require("react");
class AppProvider extends React.Component {
    getChildContext() {
        return {
            app: this.props.context
        };
    }
    render() {
        return (React.createElement(React.Fragment, null, this.props.children));
    }
}
exports.AppProvider = AppProvider;
AppProvider.childContextTypes = {
    app: () => null
};
//# sourceMappingURL=AppProvider.js.map